import React, { useEffect } from 'react';
import {
    Col,
    Row,
    InPageAlert,
    ContentContainer,
    FormHeader,
    IconNotificationSuccess
} from '@snsw/react-component-library';
import styled from 'styled-components';
import { BusinessDisasterEligibility, useApplicationConfig, useApplicationContext } from '../../store';
import { scrollToTop } from '../../Helpers';
import { QuickfeedStyleOverride, Stepper, Steps, ThumbsUpThumbsDown } from '../../Components';

const HeadingWrapper = styled.h2`
  margin-top: 3rem;
  margin-bottom: 1rem;
  font-size: 28px;
`;

const TextMargin = styled.span`
  margin-top: 0.5rem;
`;

const StepperHeadingWrapper = styled.h2`
  margin-top: 56px;
  margin-bottom: 0rem;
  font-size: 28px;
`;

const FormHeaderWrapper = styled.div`
  margin-bottom: -1rem;
`;

const SpacingWrapper = styled.div`
  padding-top: 0.5rem;
`;

export const getDefaultWhatsNextSteps = () : Array<Steps> => [
    {
        complete: true,
        title: 'Application under review',
        text:
                ['Assessment of your application may take up to 28 days.',
                    <TextMargin
                        key='1'
                    />, 'We\'ll contact you if we need more information. This can add an extra 5 business days. We may then need to do further assessment.']
    },
    {
        complete: false,
        title: 'Assessment complete',
        text:
                ['We\'ll notify you via email if your application is successful. You can expect payment within 10 business days.',
                    <TextMargin key='2' />, 'We\'ll also notify you if your application is not successful.']
    },
    {
        complete: false,
        title: 'Payment (if successful)',
        text:
                ['If you’re successful, we\'ll notify you when we\'ve  paid into your nominated bank account.']
    },
];

export const GaasConfirmationPage: React.FC = () => {
    const config = useApplicationConfig();
    const { globalState } = useApplicationContext();
    const { profileConnectInfo, userInfo, review, eligibility } = globalState;

    const currentLocaleDate = () => {
        const date = new Date();
        const month = date.toLocaleString('default', { month: 'long' });
        const current_date = `${date.getDate()} ${month} ${date.getFullYear()}`;
        return current_date;
    };

    useEffect(() => {
        scrollToTop();
        const valid = review?.referenceNumber?.length > 0;
        if (!valid) {
            scrollToTop();
            console.error('Invalid confirmation page references');
            //history.push('/review-page');
            return;
        } else {
            console.error(`Valid confirmation page references: ${review.referenceNumber}`);
        }
    }, [review]);

    return (
        <>
            <FormHeaderWrapper>
                <FormHeader
                    label={ config.appTitle }
                    title={ <><IconNotificationSuccess size='md' /> Application submitted for assessment</> }
                />
            </FormHeaderWrapper>
            <ContentContainer>
                <Row>
                    <Col span={ 8 }>
                        <InPageAlert variant='info' title="We've received your application">
                            <p>We've sent a confirmation email to {userInfo?.email || profileConnectInfo?.email}</p>
                        </InPageAlert>
                    </Col>
                </Row>
                <HeadingWrapper>Application details</HeadingWrapper>
                <Row>
                    <Col span={ 8 }>
                        <Row>
                            <Col span={ 4 }><SpacingWrapper>Reference number:</SpacingWrapper></Col>
                            <Col span={ 4 }><SpacingWrapper><strong
                                className='customer-reference'
                            >{review?.referenceNumber ?? 'not specified'}</strong></SpacingWrapper></Col>
                        </Row>
                        <Row>
                            <Col span={ 4 }><SpacingWrapper>Application:</SpacingWrapper></Col>
                            <Col span={ 4 }><SpacingWrapper><strong>{config.appTitle}</strong></SpacingWrapper></Col>
                        </Row>
                        <Row>
                            <Col span={ 4 }><SpacingWrapper>Lodgement date:</SpacingWrapper></Col>
                            <Col span={ 4 }><SpacingWrapper><strong>{currentLocaleDate()}</strong></SpacingWrapper></Col>
                        </Row>
                        {config?.confirmationPage?.showClaimAmount &&
                            <Row>
                                <Col span={ 4 }><SpacingWrapper>Claim amount:</SpacingWrapper></Col>
                                <Col span={ 4 }><SpacingWrapper><strong>
                                    {globalState?.eligibility?.claimAmount ?? 'not-set'}
                                </strong></SpacingWrapper></Col>
                            </Row>}
                        {(eligibility as BusinessDisasterEligibility)?.business?.businessName &&
                            <Row>
                                <Col span={ 4 }><SpacingWrapper>Business name:</SpacingWrapper></Col>
                                <Col span={ 4 }><SpacingWrapper><strong>
                                    {(eligibility as BusinessDisasterEligibility)?.business?.businessName}
                                </strong></SpacingWrapper></Col>
                            </Row>
                        }
                        {(eligibility as BusinessDisasterEligibility)?.business?.abn &&
                            <Row>
                                <Col span={ 4 }><SpacingWrapper>ABN:</SpacingWrapper></Col>
                                <Col span={ 4 }><SpacingWrapper><strong>
                                    {(eligibility as BusinessDisasterEligibility)?.business?.abn}
                                </strong></SpacingWrapper></Col>
                            </Row>
                        }
                    </Col>
                </Row>

                <StepperHeadingWrapper>What happens next?</StepperHeadingWrapper>
                <Row>
                    <Col span={ 8 }> <Stepper steps={ config.confirmationPage?.whatsNext ?? getDefaultWhatsNextSteps() } /></Col>
                </Row>

                <QuickfeedStyleOverride>
                    <Row className='feedback-row'>
                        <Col span={ 8 }>
                            <ThumbsUpThumbsDown
                                sourceApplication={ config.confirmationPage?.tutdSourceApplication ?? config.productCode }
                                environment={ config.confirmationPage?.tutdEnvironment ?? 'uat' }
                            />
                        </Col>
                    </Row>
                </QuickfeedStyleOverride>

            </ContentContainer>
        </>
    );
};
